import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useOnline } from '@vueuse/core'
import { AdminLayout, FormLayout, OfflineLayout } from '@component/Layouts'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const online = useOnline();

const isDashboard = computed(() => route.name?.toString().includes("Admin."));

return (_ctx: any,_cache: any) => {
  return (!_unref(online))
    ? (_openBlock(), _createBlock(_unref(OfflineLayout), { key: 0 }))
    : (isDashboard.value)
      ? (_openBlock(), _createBlock(_unref(AdminLayout), { key: 1 }))
      : (_openBlock(), _createBlock(_unref(FormLayout), { key: 2 }))
}
}

})